import { Button } from '@/common/components/button';

/**
 * Displays an error screen whenever the app experiences an unhandled exception.
 */
export function RootErrorFallback() {
  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center text-red-500"
      role="alert"
    >
      <h2 className="text-lg font-semibold">Oops, we ran into a snag...</h2>
      <Button
        className="mt-4"
        onClick={() => window.location.assign(window.location.origin)}
      >
        Refresh
      </Button>
    </div>
  );
}
